export const PROJECTS = [
  {
    project_title: "Smart Shopper",
    img_url:
      "https://github.com/djlisko01/cs5520-team2-smart-shopper/blob/main/app/src/main/ic_launcher_bag-playstore.png?raw=true",
    github: "https://github.com/djlisko01/cs5520-team2-smart-shopper",
    description:
      "An Android application where users can post deals and discuss savings with other users through comments in a forum-like format.",
    tools: ["Android", "Java", "Firebase Databases"],
  },
  {
    project_title: "Eye-RecAIcle",
    img_url: "https://github.com/greeny90/recycle-ai/raw/main/logo.png",
    github: "https://github.com/djlisko01/recycle-ai",
    description:
      "This is an IoT device that allows users to identify the appropriate bins for disposing of recycled waste.",
    tools: [
      "Python",
      "PyTorch",
      "NumPy",
      "Pandas",
      "Matplotlib",
      "OpenCV",
      "Jupyter Notebook",
      "Jetson Nano",
      "Arduino Board",
    ],
  },
  {
    project_title: "Hamper Dash",
    img_url:
      "https://github.com/michaelchang106/laundryApp/blob/main/front/public/laundryIconBlue.png?raw=true",
    github: "https://github.com/michaelchang106/laundryApp",
    description:
      "A full-stack web application that connects customers and laundry service providers where clients can request services.",
    tools: [
      "JavaScript(ES6)",
      "Node JS",
      "CSS",
      "Bootstrap",
      "HTML5",
      "React",
      "MongoDB",
    ],
  },
  {
    project_title: "Study Report Generator",
    img_url: null,
    github: null,
    description:
      "Created a desktop application that generates a summary report for sequencing data.",
    tools: ["Python", "Tkinter", "NumPy", "Pandas"],
  },
];
